import { useState, useCallback } from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';

export type AlertMessage = {
    id: number;
    message: string;
    severity?: AlertColor;
};

export const useMessage = () => {
    const [ messages, setMessages ] = useState<AlertMessage[]>([]);

    const showMessage = useCallback((message: string, severity: AlertColor = 'info') => {
        setMessages(prev => [ ...prev, { id: Date.now(), message, severity } ]);
    }, []);

    const MessageContainer = () => (
        <>
            {messages.map(t => (
                <Snackbar
                    key={t.id}
                    open
                    autoHideDuration={3000}
                    onClose={() => setMessages(prev => prev.filter(p => p.id !== t.id))}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Alert
                        onClose={() => setMessages(prev => prev.filter(p => p.id !== t.id))}
                        severity={t.severity}
                        sx={{ width: '100%' }}
                    >
                        {t.message}
                    </Alert>
                </Snackbar>
            ))}
        </>
    );

    return { showMessage, MessageContainer };
};